import script from "./PexCollectionNext.vue?vue&type=script&setup=true&lang=js"
export * from "./PexCollectionNext.vue?vue&type=script&setup=true&lang=js"

import "./PexCollectionNext.vue?vue&type=style&index=0&id=55c3ad8d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c3ad8d"]])

export default __exports__